import { Component, Input, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import * as Plotly from 'plotly.js/dist/plotly.js';
import { FONT_FAMILY } from '../../../../../core/common/constants/styles.constants';

@Component({
  selector: 'kt-chat-graph',
  templateUrl: './chat-graph.component.html',
  styleUrls: ['./chat-graph.component.scss']
})
export class ChatGraphComponent implements AfterViewInit, OnDestroy {

  @Input() data!: any;
  @ViewChild('plotly', { static: true }) plotly!: ElementRef<HTMLDivElement>;

  ngAfterViewInit(): void {
    if (!this.data) {
      return;
    }
    if (this.data.layout) {
      this.data.layout.font = { ...FONT_FAMILY };
      // hoverlabel.font does NOT inherit from layout.font (except unified hovermode); set family.
      this.data.layout.hoverlabel = {
        ...this.data.layout.hoverlabel,
        font: { ...this.data.layout.hoverlabel?.font, family: FONT_FAMILY.family }
      };
    }
    Plotly.newPlot(
      this.plotly.nativeElement,
      this.data.data,
      this.data.layout,
      {
        responsive: true,
        displaylogo: false
      }
    );
  }

  ngOnDestroy(): void {
    if (this.plotly?.nativeElement) {
      Plotly.purge(this.plotly.nativeElement);
    }
  }
}
